import config from '@config';

const AGENTS_URL = config.VITE_AGENTS_API_URL;

/** Where the login comes back to: the current path with its query. */
export const currentPath = () =>
  window.location.pathname + window.location.search;

/**
 * `/agents/login` returns the browser to `returnUrl` afterwards. `silent` asks Identity Server for `prompt=none`; a
 * silent login that cannot complete comes back with `login=required` added to `returnUrl` (ADR-0004 §2.3).
 */
export const loginUrl = (returnUrl: string, { silent = false } = {}) =>
  `${AGENTS_URL}/login?${silent ? 'silent=true&' : ''}returnUrl=${encodeURIComponent(returnUrl)}`;

/** The sign-in window ends on `/auth/done`, which tells the panel and closes (§2.4). */
export const WINDOW_LOGIN_URL = loginUrl('/auth/done');

/** Ends the chat's session and the Identity Server session (§2.6). */
export const LOGOUT_URL = `${AGENTS_URL}/logout?returnUrl=${encodeURIComponent('/')}`;

/** Removes `login=required` (the end of a failed silent login) from the address; true when it was there. */
export const takeLoginRequired = (): boolean => {
  const url = new URL(window.location.href);
  if (url.searchParams.get('login') !== 'required') return false;

  url.searchParams.delete('login');
  window.history.replaceState(
    window.history.state,
    '',
    url.pathname + url.search + url.hash,
  );
  return true;
};
